import React from "react";
import { registerLookup } from "@redriver/cinnamon";
import {
  getCountries,
  getDrivingLicences,
  getGenderOptions,
  getTitles,
  getUniformSizes,
} from "./actions";

export const countriesLookup = registerLookup("countriesLookup", getCountries, {
  transform: (data) => {
    const uk = data.find((x) => x.code == "GBR");
    return [uk, ...data.filter((x) => x.code != "GBR")].map((x) => ({
      ...x,
      value: parseInt(x.value),
    }));
  },
  cache: true,
});
export const genderLookup = registerLookup("genderLookup", getGenderOptions);

export const titlesLookup = registerLookup("titlesLookup", getTitles);
export const uniformSizesLookup = registerLookup(
  "uniformSizes",
  getUniformSizes
);
